import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import UsuarioTable from './components/UsuarioTable';
import UsuarioToolbar from './components/UsuarioToolbar/UsuarioToolbar';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import { NotFound as NotFoundView } from '../index';
import { isAuthenticated } from '../../helpers/authenticate';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  divFab:{
    zIndex: 2
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

function UsuarioList({history}) {
  const timeout = ServiceValues.timeout;
  const baseUrl = ServiceValues.base_url_local;
  const api = ServiceAxios(baseUrl, timeout);
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [usuarios, setUsuarios] = useState({
    result: []
  });
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [showDialogConfirmacaoDeleteUsuario, setShowDialogConfirmacaoDeleteUsuario] = useState(false);
  const [selectedIndexUsuario, setSelectedIndexUsuario] = useState(-1);
  const [cnpjConfirmation, setCnpjConfirmation] = useState('');
  const [sucess, setSucess] = useState(true);
  const [openUsuarioChangePassword, setOpenUsuarioChangePassword] = useState(false);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState({});
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [replicaNovaSenha, setReplicaNovaSenha] = useState('');
  const [mostrarSenhaAtual, setMostrarSenhaAtual] = useState('');
  const [mostrarNovaSenha, setMostrarNovaSenha] = useState('');
  const [mostrarReplicaNovaSenha, setMostrarReplicaNovaSenha] = useState('');

  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  useEffect(() => {
    async function carregarUsuarios() {
      try{
        setLoading(true);
        const params = {
          limit: 100,
        };
        const dados = await api.get('usuarios/', {params: params});
        setLoading(false);
        if(dados.data.isSuccess){
          if(dados.data.result.length !== 0){
            for(let i = 0, size = dados.data.result.length; i < size; i++){
              dados.data.result[i].on_mouse_over = false;
            }
            setUsuarios(dados.data);
          }
          else{
            setLoading(false);
            setTypeSnack('warning');
            setMessageSnack('Não há usuários cadastrados');
            setShowMessageSnack(true);
          }
        }
        else{
          setSucess(false);
        }

      }
      catch (e) {
        setSucess(false);

      }
    }
    carregarUsuarios();
  }, []);


  function showConfirmationDeleteUsuario(index){
    if (selectedIndexUsuario < 0 && selectedIndexUsuario >= usuarios.result.length) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack('Não foi possível deletar o usuário');
      setShowMessageSnack(true);
    }
    else{
      setSelectedIndexUsuario(index);
      setShowDialogConfirmacaoDeleteUsuario(true);
    }

  }

  async function deleteUsuario() {
    if (selectedIndexUsuario < 0 && selectedIndexUsuario >= usuarios.result.length) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack('Não foi possível deletar o usuário');
      setShowMessageSnack(true);
    }
    else{
      try {
        setShowDialogConfirmacaoDeleteUsuario(false);
        setLoading(true);
        const id = usuarios.result[selectedIndexUsuario].idUsuario;
        const dados = await api.delete(`usuarios/${id}`);
        setCnpjConfirmation('');
        if (dados.data.isSuccess === true) {
          const params = {
            limit: 100,
          };
          const dados = await api.get('usuarios/', { params: params });
          setLoading(false);
          if (dados.data.isSuccess === true) {
            setTypeSnack('success');
            setMessageSnack('Usuario deletado com sucesso');
            setShowMessageSnack(true);
            for (let i = 0, size = dados.data.result.length; i < size; i++) {
              dados.data.result[i].on_mouse_over = false;
            }
            setUsuarios(dados.data);
          } else {
            setTypeSnack('error');
            setMessageSnack('Erro ao carregar usuários');
            setShowMessageSnack(true);
          }
        } else {
          setTypeSnack('error');
          setMessageSnack('Erro ao deletar usuário');
          setShowMessageSnack(true);
        }

      } catch (e) {
        setCnpjConfirmation('');
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack('Erro ao deletar usuário');
        setShowMessageSnack(true);
      }

    }
  }

  function onCancelDeleteUsuario() {
    setSelectedIndexUsuario(-1);
    setShowDialogConfirmacaoDeleteUsuario(false)
  }

  async function filterUsuarios(filterValue) {
    try {
      setLoading(true);
      const params = {
        limit: 100,
        nome: filterValue,
        email: filterValue,
        cpfCnpj: filterValue
      };
      const dados = await api.get('usuarios/filter', { params: params });
      setLoading(false);
      if (dados.data.isSuccess) {
        for (let i = 0, size = dados.data.result.length; i < size; i++) {
          dados.data.result[i].on_mouse_over = false;
        }
        setUsuarios(dados.data);
      } else {
      }

    } catch (e) {
      console.log(e.toString())
    }
  }

  function openUsuarioRegister() {
    const usuario = {
      nome: '',
      nomeFantasia: '',
      cpfCnpj: '',
      pessoa_fisica: '',
      email: '',
      sexo: '',
      dataNascimento: null,
      idTipoUsuario: '',
      login: '',
      senha: '',
      enderecos: [],
      telefones: [],
      empresas: []
    };
    history.push('/usuario-register/', {usuario: usuario, edicao: false});
  }

  async function openUsuarioEdit(index) {
    try{
      if (index < 0 && index >= usuarios.result.length) {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack('Não foi possível editar o usuário');
        setShowMessageSnack(true);
      } else {
        setLoading(true);
        const dados = await api.get(`usuarios/${usuarios.result[index].idUsuario}`);
        setLoading(false);
        if(dados.data.isSuccess){
          if(dados.data.result.length > 0){
            history.push('/usuario-edit/', {usuario: dados.data.result[0], edicao: true});
          }
          else{
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack('Ocorreu um erro ao obter dados do usuário.');
            setShowMessageSnack(true);
          }
        }
        else{
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack('Ocorreu um erro ao obter dados do usuário.');
          setShowMessageSnack(true);
        }
      }
    }
    catch (e) {
      setSucess(false);
    }
  }


  return (
    sucess
    ?
      <div
        className={classes.root}
      >
        <UsuarioToolbar
          filterUsuarios={filterUsuarios}
        />
        <SnackbarCustom
          verticalOrientation='bottom'
          horizontalOrientation='center'
          open={showMessageSnack}
          setOpen={setShowMessageSnack}
          message={messageSnack}
          duration={2000}
          type={typeSnack}
        />
        <Dialog open={showDialogConfirmacaoDeleteUsuario} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Remoção de usuário</DialogTitle>
          <DialogContent>
            <Typography gutterBottom>
              Você está tentando deletar o usuário com as seguintes informações:
            </Typography>
            <Typography
              gutterBottom
              style={{marginTop: '30px'}}
            >
              {selectedIndexUsuario < 0 || selectedIndexUsuario >= usuarios.result.length ? '' :
                'Nome: ' + usuarios.result[selectedIndexUsuario].nome
              }
            </Typography>
            <Typography
              gutterBottom
              style={{marginBottom: '30px'}}

            >
              {selectedIndexUsuario < 0 || selectedIndexUsuario >= usuarios.result.length ? '' :
                'CPF: ' + usuarios.result[selectedIndexUsuario].cpfCnpj
              }
            </Typography>
            <Typography gutterBottom>
              Tem certeza que deseja excluir esse usuário?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancelDeleteUsuario} color="primary">
              Cancel
            </Button>
            <Button onClick={deleteUsuario} color="primary">
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
        <div className={classes.content}>
          <ProgressFullScreen
            open={loading}
            setOpen={setLoading}
          />
          <UsuarioTable
            usuarios={usuarios}
            setUsuarios={setUsuarios}
            deleteEmpresa={showConfirmationDeleteUsuario}
            editEmpresa={openUsuarioEdit}
            showMessageSnack={showMessageSnack}
            setShowMessageSnack={setShowMessageSnack}
            messageSnack={messageSnack}
            setMessageSnack={setMessageSnack}
            typeSnack={typeSnack}
            setTypeSnack={setTypeSnack}
          />
        </div>
        <div
          className={classes.divFab}

        >
          <Fab
            aria-label={'Add'}
            className={classes.fab}
            color={'primary'}
            variant={'round'}
            onClick={openUsuarioRegister}
          >
            <AddIcon />
          </Fab>
        </div>
      </div>
      :
      <NotFoundView/>

  );
};

export default UsuarioList;
